module.exports = __webpack_public_path__ + "static/media/zhafran_fajar_b.600d9552.jpg";